<template>
  <div id="event-notify" role="form">
    <div>
      <label class="font-normal">
        Would you like to notify the team that {{ eventName() }} has changed?
      </label>
      <div class="m-t-xs">
        <label class="radio-inline">
          <input type="radio" value="none" id="none" v-model="rosterFilter"> Don't send notifications
        </label>
      </div>
      <div v-if="rosters.length > 0" class="m-t-xs">
        <label class="radio-inline">
          <input type="radio" value="rosters" id="rosters" v-model="rosterFilter"> Notify linked rosters: {{ rosterNames }}
        </label>
      </div>
      <div class="m-t-xs">
        <label class="radio-inline">
          <input type="radio" value="all" id="all" v-model="rosterFilter"> Notify entire team
        </label>
      </div>
    </div>
    <div class="flex flex-col gap-y-sm m-t-m">
      <ladda-button @lbClicked="pingServer" el-class="btn-primary w-full" :loading="loading">
        <span v-if="rosterFilter === 'none'">Continue without notifying</span>
        <span v-else-if="rosterFilter === 'rosters'">Send notifications to linked rosters</span>
        <span v-else-if="rosterFilter === 'all'">Send notifications to entire team</span>
        <span v-else>Save</span>
      </ladda-button>
      <div v-show="error">
        <small>
          <span class="text-danger">{{ errorMessage }}</span>
        </small>
      </div>
    </div>
  </div>
</template>
<script>
import LaddaButton from '../../shared/ladda_button.vue';

export default {
  name: 'event-change-notify',
  components: { LaddaButton },
  props: {
    event: {
      type: Object,
      required: true,
    },
    recurringChange: {
      type: Boolean,
      default: false,
    },
    // 'future' when the delete was 'this and following events'; null otherwise
    recurringScope: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      rosterFilter: 'none',
      loading: false,
      error: false,
      errorMessage: 'Error, please try again later or contact support.',
    };
  },
  computed: {
    rosters() {
      return _.map(this.event.roster_events, 'roster');
    },
    rosterNames() {
      return _.join(_.map(this.rosters, 'name'), ', ');
    },
    rosterIdsToNotify() {
      if (this.rosterFilter === 'rosters') {
        return _.map(this.rosters, 'id');
      }

      return null;
    },
  },
  methods: {
    eventName() {
      const { event } = this;
      return event.title || event.name;
    },
    hideForm() {
      const vm = this;
      vm.$notificationManager.emit('event-notify-close', vm.event);
    },
    pingServer() {
      const vm = this;

      if (vm.loading) {
        return;
      }

      if (vm.rosterFilter === 'none') {
        vm.hideForm();
        return;
      }

      vm.loading = true;

      const url = vm.$apiService.eventNotifyUrl(vm.event.id);
      const params = {
        recurring: vm.recurringChange,
        recurring_scope: vm.recurringScope,
        roster_ids: vm.rosterIdsToNotify,
      };
      axios.post(url, params)
        .then((response) => {
          vm.$notificationManager.emit('show-toast', 'Sending notifications', true);
          vm.loading = false;
          vm.hideForm();
        })
        .catch((error) => {
          vm.loading = false;
          vm.error = true;
          vm.errorMessage = 'Error triggering team notification';
        });
    },
  },
};
</script>
